import { useNavigate } from "react-router-dom"
import "../css/fonnav.css"
import useGenStore from "../store/store"

function Fonav(){
    const navigate = useNavigate()
    const setMenuActive=useGenStore((s)=>s.setMenuActive)
    const toHome=()=>{
                setMenuActive(false)

        navigate("/")
    }

    const toPractice=()=>{
        setMenuActive(false)
        navigate("/practice-areas")
    }
    const toServices=()=>{
                setMenuActive(false)

        navigate("/services")
    }
    const toAbout=()=>{
                setMenuActive(false)

        navigate("/about")
    }
    const toContact=()=>{
                setMenuActive(false)

        navigate("/contact")
    }
    const closeMenu=()=>{
                setMenuActive(false)
    }
    return(
        <div className="fonnavWrap">
            <p onClick={()=>toHome()}>Home</p>
            <p onClick={()=>toPractice()}>Practice Areas</p>
            <p onClick={()=>toServices()}>Services</p>
            <p onClick={()=>toAbout()}>About Me</p>
            <p onClick={()=>toContact()}>Contact</p>
            <div className="cancelFon" onClick={()=>closeMenu()}>
                  x
            </div>

        </div>
    )
}

export default Fonav;